import { api } from '../../../plugins/axios';
import { Alert } from '../../../plugins/alert';
import { t } from '../../../../locales';
import { base64ToBlob } from '../../../utils/file-upload';

export const invoiceTypes = Object.freeze({
	SIMPLE: 0,
	CREDIT: 1,
});
export default class Invoice {
	type = undefined;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	get isSimpleInvoice() {
		return this.type === invoiceTypes.SIMPLE;
	}

	get isCredit() {
		return this.type === invoiceTypes.CREDIT;
	}

	// static async fetchOrderInvoice(orderId, type) {
	// 	const { data } = await api.post(`/zatca/generate-invoice/${orderId}`, { type });

	// 	return new Invoice({ ...data.result, type });
	// }

	static async generateOrderInvoice(orderId) {
		// return await this.mockInvoice();
		try {
			const { data } = await api.get(`/zatca/generate-invoice/${orderId}`, {
				params: {
					type: invoiceTypes.SIMPLE,
				},
			});
			const pdf = data.pdf;
			const blob = base64ToBlob(pdf, 'application/pdf');
			return blob;
		} catch (err) {
			const msg = err?.response?.data?.message;
			Alert.error(msg || t('Error Msg'));
			console.error(err);
			throw err;
		}
	}

	static async generateOrderReturnInvoice(orderId) {
		// return await this.mockInvoice();
		try {
			const { data } = await api.get(`/zatca/generate-invoice/${orderId}`, {
				params: {
					type: invoiceTypes.CREDIT,
				},
			});
			const pdf = data.pdf;
			const blob = base64ToBlob(pdf, 'application/pdf');
			return blob;
		} catch (err) {
			const msg = err?.response?.data?.message;
			Alert.error(msg || t('Error Msg'));
			console.error(err);
			throw err;
		}
	}

	static async mockInvoice() {
		const { data } = await api.get(`/mock-invoice`);
		const pdf = data.pdf;
		const blob = base64ToBlob(pdf, 'application/pdf');
		return blob;
		// const blob = new Blob([data], { type: 'application/pdf' });
		// return blob;
	}

	static async getOrderInvoiceById(id) {
		return api.get(`/my-fatoorah/transactions/${id}`).then((res) => res.data.result.invoice);
	}
}
